import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';

export default function OrderErrorDialog({ open, errorType }) {
  const { t } = useTranslation();

  const errorMessage = useMemo(() => {
    if (errorType === 'EVENT_STARTED_ERROR') return t('eventAlreadyStarted');
    if (errorType === 'EVENT_NOT_AVAILABLE_ERROR') return t('eventNotAvailable');
    if (errorType === 'PRICE_MISMATCH_ERROR') return t('pricesUpdated');
    return '';
  }, [errorType, t]);

  return (
    <Dialog open={open}>
      <DialogTitle>{t('Oops!')}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>{errorMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {errorType === 'PRICE_MISMATCH_ERROR' ? (
          <Button onClick={() => window.location.reload(true)} variant="contained">
            {t('Reload')}
          </Button>
        ) : (
          <Button onClick={() => (window.location.href = 'https://www.poftimcultura.ro')} variant="contained">
            {t('Home Page')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
